/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, bool, string, func, number, shape, arrayOf,
} from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import withStyles from '@material-ui/core/styles/withStyles';
import Media from 'react-media';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import BackButton from '../../common/BackButton';
import Loading from '../../common/Loading';
import { isEmpty } from '../../utils/object';
import EventDispatcher from '../../state/reducers/EventDispatcher';
import DeliveryHours from '../TrackOrder/DeliveryHours';
import ItemDetail from './ItemDetail';
import BillingDetail from './BillingDetail';
import Infos from './Sections/Infos';
import OrderNumber from './Sections/OrderNumber';
import { getFeatureFlags } from '../../utils/featureSelectors';
import getSiteConfig from '../../utils/getSiteConfig';
import CUSTOM_BREAKPOINTS from '../../style/customBreakpoints';
import DesktopOrderDetails from '../DesktopOrderDetails/DesktopOrderDetails';
import DesktopOrderHeader from '../DesktopOrdersList/DesktopOrderHeader';
import DesktopOrderList from '../DesktopOrdersList/DesktopOrderList';
import ROSSDesktopOrderList from '../DesktopOrdersList/ROSSDesktopOrderList';
import MobileOrderHeader from '../MobileOrderList/MobileOrderHeader';
import MobileOrderList from '../MobileOrderList/MobileOrderList';
import ROSSMobileOrderList from '../MobileOrderList/ROSSMobileOrderList';
import AccountLeftMenu from '../../common/Desktop/AccountLeftMenu';
import { OrderDetailsStyle } from '../../style/OrderDetailsStyle';
import { determineLanguagePrefixPath } from '../../../../helpers/determineInternationalizationPath';
import configENV from '../../config';

import { getBrand } from '../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { getDataDictionary, getSSRDeviceType } from '../../../../../state/ducks/App/App-Selectors';
import { getLanguageName } from '../../../../../state/ducks/Member/ducks/Auth/helper/helper';

const { PERSIST_KEY } = configENV;

const styles = ({ typography, palette }) => OrderDetailsStyle(typography, palette);

class OrderDetails extends React.Component {
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = () => {
        const {
            match: {
                params: {
                    uuid, order, zip, status,
                },
            },
            orderNumber,
            zipCode,
            billingZipCode,
            fetchOrderDetails,
            featureFlags,
            ssrDeviceType,
            ROSSOrder,
        } = this.props;
        // Added update = true for graphQL to query order details
        // after successfully validated recipient and billing zip code
        // eslint-disable-next-line object-curly-newline
        const options = order ? { order, zip, status, update: true } : null;
        // hardcode billing zip code for .CA. - only on uat2 and prod
        // This is the billing zip code of house account billing address.
        const newBillingZipCode = featureFlags?.['is-order-tracking-billing-zipcode-hidden'] ? 'V7R 4X6' : billingZipCode;
        if (
            uuid
            && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(uuid)
        ) {
            if (ROSSOrder?.orderID !== orderNumber) {
                fetchOrderDetails(
                    uuid,
                    orderNumber,
                    zipCode,
                    newBillingZipCode,
                    options,
                    featureFlags,
                    ssrDeviceType,
                );
            }
        }
    };

    componentDidMount = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    };

    getOrderItemList = (uuid, order, brand, mobile) => {
        const { userProfile } = this.props;
        const orderItem = {
            uuid,
            orderNumber: order.orderNumber,
            orderDate: order.orderDate,
            items: [{ ...order }],
            className: '',
        };

        return mobile ? <MobileOrderList key={order.intOrderNumber} order={orderItem} className="" userProfile={userProfile} brand={brand} />
            : <DesktopOrderList key={order.intOrderNumber} order={orderItem} className="" userProfile={userProfile} brand={brand} />;
    }

    getROSSOrderItemList = (order, brand, mobile) => {
        const orderItem = [{ ...order }];
        return mobile ? <ROSSMobileOrderList order={orderItem} brand={brand} /> : <ROSSDesktopOrderList order={orderItem} brand={brand} />;
    };

    getOrderNumber = (orderDetailById) => {
        const { featureFlags, ROSSOrder } = this.props;
        const isROSSEnabled = featureFlags?.['is-order-page-using-ross-endpoint'];
        let orderNumber = '';
        if (isROSSEnabled) {
            orderNumber = ROSSOrder?.orderID;
        } else {
            orderNumber = orderDetailById?.[0]?.orderNumberPure || orderDetailById?.[0]?.orderNumber;
        }
        return orderNumber;
    }

    errorScreen = () => {
        const { dataDictionary } = this.props;
        return (
            <div className="orderDetails">
                <h1>
                    <BackButton url={determineLanguagePrefixPath('/track-order')} />
                    {getLanguageName() === '/en' ? 'Order Details' : dataDictionary?.['Order Details'] || 'Order Details'}
                </h1>
                <div className="error-inline">
                    {getLanguageName() === '/en' ? 'Unable to obtain order details for this order' : dataDictionary?.['Unable to obtain order details for this order'] || 'Unable to obtain order details for this order'}
                </div>
            </div>
        );
    }

    nonAuthenticatedScreen = () => (
        <div>
            <div className="margin-bottom-4px">
                <span className="non-auth-title">For the customer:</span>To view your complete order history, or to make modifications to your order, please sign-in to your account for more information.
            </div>
            <div>
                <span className="non-auth-title">For the recipient:</span>If you need more information, or you have questions or concerns regarding your gift, please contact customer service at {getSiteConfig('phoneNumber')}.
            </div>
        </div>
    )

    print = () => {
        if (typeof window !== 'undefined') {
            window.print();
        }
    }

    render() {
        const {
            match: {
                params: { uuid },
            },
            classes,
            orderDetails,
            userProfile,
            userProfile: { isAuthenticated },
            isFetchingModal,
            featureFlags,
            history,
            breakpoint,
            brand,
            dataDictionary,
            ROSSOrder,
            requestStatus,
            orderDataLoaded,
        } = this.props;

        const orderIndex = uuid;
        const isROSSEnabled = featureFlags?.['is-order-page-using-ross-endpoint'];

        const intOrderNumberList = [];
        // Loading screen
        if (isFetchingModal || !orderDataLoaded) {
            return <Loading />;
        }
        if (!isROSSEnabled && ((isEmpty(orderDetails) && requestStatus === 200) || requestStatus === 400 || !uuid)) {
            return this.errorScreen();
        }

        // Redirect to /account/orders if orderDetails[orderIndex] is empty
        // Redirect to /track-order if orderDetails[orderIndex] is empty and the brand is 08F
        const orderDetailById = orderDetails[orderIndex];
        if (!isROSSEnabled && (!orderDetailById || orderDetailById.length < 1)) {
            if (!isAuthenticated && (brand.code === '08F' || brand.code === 'CAN')) {
                history.replace(determineLanguagePrefixPath('/track-order'));
            } else if (!isAuthenticated) {
                history.replace('/account/orders');
            }
            return this.errorScreen();
        }

        // Check recipientDetail Object to determind whether it's from getOrderByIdAndZipcode or getDetailedOrderById response
        const recipientDetail = orderDetailById?.[0]?.recipientDetail;
        const isGetOrderByIdAndZipcode = isEmpty(ROSSOrder) && typeof recipientDetail === 'undefined';
        const title = isGetOrderByIdAndZipcode ? 'Orders' : 'Order Details';
        const breakpointExpr = `(max-width: ${(breakpoint || CUSTOM_BREAKPOINTS.tabLandscape)}px)`;
        const language = getLanguageName();

        if (orderDataLoaded) {
            return (
                <>
                    {(brand.code === '08F' || brand.code === 'CAN')
                        ? (
                            <Media query={breakpointExpr}>
                                {(matches) => (
                                    matches ? (
                                        <div className={classes.OrderDetailsStyle}>
                                            <div><MobileOrderHeader />
                                                <div className="orderDetailsContainer">
                                                    <h1>
                                                        {language === '/en' ? `Order #${this.getOrderNumber(orderDetailById)}`
                                                            : `${dataDictionary?.['Order'] || 'Order'} #${this.getOrderNumber(orderDetailById)}`}
                                                    </h1>
                                                </div>
                                                <div className="orderItemsContainer">
                                                    {!isROSSEnabled
                                                        ? orderDetailById?.map((order) => (
                                                            this.getOrderItemList(uuid, order, brand, true)
                                                        ))
                                                        : ROSSOrder?.orders?.map((order) => this.getROSSOrderItemList(order, brand, true))}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                        : (
                                            <div className={classes.OrderDetailsStyle}>
                                                <div><DesktopOrderHeader brand={brand} />
                                                    <div className="orderDetailsContainer">
                                                        <h1>
                                                            {language === '/en' ? `Order #${this.getOrderNumber(orderDetailById)}`
                                                                : `${dataDictionary?.['Order'] || 'Order'} #${this.getOrderNumber(orderDetailById)}`}
                                                        </h1>
                                                    </div>
                                                    <div className="orderItemsContainer">
                                                        {!isROSSEnabled
                                                            ? orderDetailById?.map((order) => (
                                                                this.getOrderItemList(uuid, order, brand)
                                                            ))
                                                            : ROSSOrder?.orders?.map((order) => this.getROSSOrderItemList(order, brand))}

                                                    </div>
                                                </div>
                                            </div>
                                        )
                                )}
                            </Media>
                        )
                        :  (
                            <Media query={breakpointExpr}>
                                {(matches) => (
                                    matches ? (
                                        <div className={classes.OrderDetailsStyle}>
                                            <h1>
                                                <BackButton url="/account/orders" />
                                                {title}
                                            </h1>

                                            {isGetOrderByIdAndZipcode ? (
                                                <>
                                                    <DeliveryHours />
                                                    {!isAuthenticated && <div className="margin-bottom-2x non-auth-user breakpoint-width"> {this.nonAuthenticatedScreen()}</div>}
                                                </>
                                            ) : (
                                                <OrderNumber orderDetailById={orderDetailById} />
                                            )}

                                            {orderDetailById.map((order) => {
                                                if (intOrderNumberList.indexOf(order.intOrderNumber) > -1) {
                                                    return null;
                                                }
                                                intOrderNumberList.push(order.intOrderNumber);
                                                return (
                                                    <ItemDetail
                                                        key={order.intOrderNumber}
                                                        uuid={uuid}
                                                        ItemDetail={order}
                                                        userProfile={userProfile}
                                                    />
                                                );
                                            })}

                                            {isAuthenticated ? (
                                                <BillingDetail orderDetailById={orderDetailById} />
                                            ) : (
                                                ''
                                            )}

                                            {!isGetOrderByIdAndZipcode ? (
                                                <Infos featureFlags={featureFlags} />
                                            ) : (
                                                ''
                                            )}

                                            <div className="padding-bottom-2x" />
                                        </div>
                                    )
                                        : (
                                            <div className={classes.OrderDetailsStyle}>
                                                {isGetOrderByIdAndZipcode ? (

                                                    <div><DesktopOrderHeader brand={brand} />
                                                        {(!isAuthenticated && brand.code !== '08F') && <div className="margin-bottom-2x non-auth-user"> {this.nonAuthenticatedScreen()}</div>}
                                                        <div className="orderDetailsContainer">
                                                            <h1>Order #{orderDetailById[0]?.orderNumberPure || orderDetailById[0]?.orderNumber}</h1>
                                                        </div>
                                                        <div className="orderItemsContainer">
                                                            {orderDetailById?.map((order) => (
                                                                this.getOrderItemList(uuid, order, brand)
                                                            ))}
                                                        </div>

                                                    </div>
                                                )
                                                    : (
                                                        <div className="desktop-view">
                                                            <Grid container>
                                                                {isAuthenticated ? <AccountLeftMenu userProfile={userProfile} featureFlags={featureFlags} /> : ''}
                                                                <Grid item xs={10} className={!isAuthenticated ? 'order-detail-guest' : ''}>
                                                                    <Grid container>
                                                                        <Grid className="position-relative" item xs={6}>
                                                                            <h2 className="dekstop-order-details-title">
                                                                                {title}
                                                                            </h2>
                                                                        </Grid>
                                                                        {!isGetOrderByIdAndZipcode ? (
                                                                            <Grid className="top-button-wrapper" item xs={6}>
                                                                                <BackButton url="/account/orders" desktopHDButton />
                                                                                <Button
                                                                                    onClick={() => this.print()}
                                                                                    variant="contained"
                                                                                    className="float-none secondary"
                                                                                >
                                                                                    Print
                                                                                </Button>
                                                                            </Grid>
                                                                        ) : ''}
                                                                    </Grid>
                                                                    <DesktopOrderDetails isAuthenticated={isAuthenticated} featureFlags={featureFlags} uuid={uuid} orderDetailById={orderDetailById} isGetOrderByIdAndZipcode={isGetOrderByIdAndZipcode} />
                                                                </Grid>

                                                            </Grid>
                                                        </div>
                                                    )}
                                            </div>
                                        )
                                )}
                            </Media>
                        )}
                </>
            );
        }

        return null;
    }
}

OrderDetails.defaultProps = {
    match: {},
    history: {},
    orderDetails: {},
    featureFlags: {},
    orderNumber: null,
    zipCode: null,
    billingZipCode: null,
    breakpoint: CUSTOM_BREAKPOINTS.tabLandscape,
    ROSSOrder: {},
};

OrderDetails.propTypes = {
    classes: object.isRequired,
    history: object,
    isFetchingModal: bool.isRequired,
    userProfile: shape({
        accessToken: string,
        idToken: string,
        ContactId: string,
        userType: string,
        userRole: string,
        email: string,
        aud: string,
        iat: number,
        exp: number,
        sub: string,
        firstName: string,
        lastName: string,
        loginsCount: number,
        isAuthenticated: bool,
        isGuestAccount: bool,
    }).isRequired,
    match: object,
    orderDetails: object, // TODO: to validate propType object with dynamic key
    featureFlags: object,
    orderNumber: string,
    zipCode: string,
    billingZipCode: string,
    fetchOrderDetails: func.isRequired,
    breakpoint: number,
    brand: object.isRequired,
    dataDictionary: object.isRequired,
    ROSSOrder: shape({
        brandId: string,
        modifiedDateTime: string,
        orderNumber: string,
        orders: arrayOf({
            actualDeliveryDate: string,
            address: string,
            carrier: string,
            courier: string,
            createdDate: string,
            currentLocation: object,
            deliveryDate: string,
            deliveryImageURL: string,
            deliveryMethod: string,
            deliveryNotes: string,
            history: arrayOf({
                codeStatus: string,
                createdDate: string,
                location: object,
                status: string,
                statusDescription: string,
            }),
            intOrderNumber: string,
        }),
        items: arrayOf({
            productBrand: string,
            itemType: string,
            productName: string,
            productSku: string,
        }),
        origin: string,
        recipientFirstName: string,
        recipientLastName: string,
        signatureImageURL: string,
        status: string,
        statusDescription: string,
        trackingNumber: string,
        type: string,
        warningMessage: string,
    }),
    ssrDeviceType: string.isRequired,
    requestStatus: number.isRequired,
    orderDataLoaded: bool.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    let featureFlags = {};
    if (state.app) {
        try {
            featureFlags = {
                ...getFeatureFlags(state),
            };
            // eslint-disable-next-line no-empty
        } catch (ex) { }
    }
    return {
        isFetchingModal: newState.isFetchingModal,
        callBack: newState.callBack,
        orderNumber: newState.orderNumber,
        zipCode: newState.zipCode,
        billingZipCode: newState.billingZipCode,
        uuid: newState.uuid,
        orderDetails: newState.orderDetails,
        featureFlags,
        brand: getBrand(state),
        dataDictionary: getDataDictionary(state),
        ROSSOrder: newState.ROSSOrder,
        ssrDeviceType: getSSRDeviceType(state),
        requestStatus: newState.requestStatus,
        orderDataLoaded: newState.orderDataLoaded,
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchOrderDetails: (uuid, orderNumber, zipCode, billingZipCode, options, featureFlags, ssrDeviceType) => dispatch(EventDispatcher.fetchOrderDetails(
        uuid,
        orderNumber,
        zipCode,
        billingZipCode,
        options,
        featureFlags,
        ssrDeviceType,
    )),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withStyles(styles, { withTheme: true })(OrderDetails)));
